module.exports = __webpack_public_path__ + "img/savory.3cae5b3b.png";